import * as Sentry from '@sentry/react';

const pinvTracker = (error) => {
  return Sentry.captureException(error);
};

export default pinvTracker;
